import React from 'react'

import { Ink } from '@acorns/web-components'

import AcornsLogo from 'assets/icons/acorns_logo_green.svg'

import { TestIDs } from '../../../test/utils/testIds'
import { enhance } from './enhance'
import {
  Link,
  Logo,
  LogoContainer,
  MiniNavContainer,
  MiniNavShim,
  StyledMinimalProgressBar,
} from './styled-components'
import { EnhancedMiniNavProps } from './types'

const MiniNav: React.SFC<EnhancedMiniNavProps> = ({
  hasBanner,
  hideProgressBar,
  linkTarget,
  linkRef,
  linkText,
  onLink,
  noShim,
  value,
  hideNav,
}) => (
  <>
    <MiniNavContainer hasBanner={hasBanner} hideNav={hideNav}>
      <LogoContainer>
        <Logo src={AcornsLogo} alt="Acorns Logo" />
      </LogoContainer>

      {linkText && (
        <Link target={linkTarget} href={linkRef} onClick={onLink} data-testid={TestIDs.NAV.LINK}>
          <Ink opacity={0.02} />
          {linkText}
        </Link>
      )}

      {!hideProgressBar && <StyledMinimalProgressBar value={value} />}
    </MiniNavContainer>
    <MiniNavShim hasBanner={hasBanner} hideNav={hideNav} noShim={noShim} />
  </>
)

export default enhance(MiniNav)
